import React, { Suspense, lazy } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';

import ManagerRoute from './ManagerRoute';
import PrivateRoute from './PrivateRoute';
import LoadingFallback from '../components/LoadingFallback';
const ClientRegistration = lazy(() => import('../pages/Client Registration'));
const Configuration = lazy(() => import('../pages/Configuration'));
const ExternalServiceRegistration = lazy(
  () => import('../pages/External Service Registration'),
);
const UpdateExternalOS = lazy(() => import('../pages/Update External OS'));
const ListOrders = lazy(() => import('../pages/List Orders'));
const ListExternalOS = lazy(() => import('../pages/List OS External'));
const ListNormalOS = lazy(() => import('../pages/List OS Normal'));
const ListReturnedOS = lazy(() => import('../pages/List OS Retorno'));
const Login = lazy(() => import('../pages/Login'));
const NormalOSRegistration = lazy(
  () => import('../pages/Normal OS Registration'),
);
const Order = lazy(() => import('../pages/Order'));
const OrderRegistration = lazy(() => import('../pages/Order Registration'));
const OS = lazy(() => import('../pages/OS'));
const PeriodCashRegister = lazy(() => import('../pages/Period Cash Register'));
const ReturnedOSRegistration = lazy(
  () => import('../pages/Returned OS Registration'),
);
const Search = lazy(() => import('../pages/Search'));
const TodayCashRegister = lazy(() => import('../pages/Today Cash Register'));
const ClientUpdate = lazy(() => import('../pages/Update Client'));
const UpdateNormalOS = lazy(() => import('../pages/Update Normal OS'));
const UpdateOrder = lazy(() => import('../pages/Update Order'));
const UpdateReturnedOS = lazy(() => import('../pages/Update Returned OS'));

function AppRoutes() {
  return (
    <BrowserRouter>
      <Suspense fallback={<LoadingFallback />}>
        <Routes>
          <Route path="/" element={<Login />} />

          <Route element={<PrivateRoute />}>
            <Route path="/consulta" element={<Search />} />

            <Route path="/listar-os-normal" element={<ListNormalOS />} />
            <Route path="/listar-os-retorno" element={<ListReturnedOS />} />
            <Route
              path="/listar-atendimento-externo"
              element={<ListExternalOS />}
            />
            <Route path="/listar-pedido" element={<ListOrders />} />

            <Route path="/cadastrar-cliente" element={<ClientRegistration />} />
            <Route path="/editar-cliente/:id" element={<ClientUpdate />} />

            <Route path="/abrir-os-normal" element={<NormalOSRegistration />} />
            <Route
              path="/abrir-os-retorno"
              element={<ReturnedOSRegistration />}
            />
            <Route
              path="/abrir-atendimento-externo"
              element={<ExternalServiceRegistration />}
            />
            <Route path="/abrir-pedido" element={<OrderRegistration />} />

            <Route path="/os/:id" element={<OS />} />
            <Route path="/pedido/:id" element={<Order />} />
            <Route path="/editar-os/:id" element={<UpdateNormalOS />} />
            <Route
              path="/editar-os-retorno/:id"
              element={<UpdateReturnedOS />}
            />
            <Route
              path="/editar-os-externa/:id"
              element={<UpdateExternalOS />}
            />
            <Route path="/editar-pedido/:id" element={<UpdateOrder />} />

            <Route element={<ManagerRoute />}>
              <Route path="/caixa-hoje" element={<TodayCashRegister />} />
              <Route path="/caixa-periodo" element={<PeriodCashRegister />} />
            </Route>

            <Route path="/configuracoes" element={<Configuration />} />
          </Route>
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
}

export default AppRoutes;
